export default function ChildPughComponent() {
  return <></>;
}
